import React, { useEffect, useState } from "react";
import { Code2, Copy, Check } from "lucide-react";

/* ===================== STYLES ===================== */
import styles from "./CodeSample.module.scss";

const CodeSample = ({ codeSamples = [] }) => {
  const [activeLang, setActiveLang] = useState("");
  const [activeCode, setActiveCode] = useState("");
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (codeSamples.length > 0) {
      setActiveLang(codeSamples[0].language);
      setActiveCode(codeSamples[0].code);
    }
  }, [codeSamples]);

  const handleTabClick = (lang) => {
    const selected = codeSamples.find((item) => item.language === lang);
    setActiveLang(lang);
    setActiveCode(selected?.code || "");
    setCopied(false);
  };

  const handleCopy = () => {
    if (!activeCode) return;

    try {
      if (navigator.clipboard?.writeText) {
        navigator.clipboard.writeText(activeCode);
      } else {
        // Fallback for older browsers
        const textarea = document.createElement("textarea");
        textarea.value = activeCode;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      }

      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      console.error("Copy failed", err);
    }
  };

  if (!codeSamples.length) return null;

  return (
    <div className={styles["admin-code-sample__card"]}>
      {/* HEADER */}
      <div className={styles["admin-code-sample__header"]}>
        <div className={styles["admin-code-sample__icon-wrapper"]}>
          <Code2 size={18} strokeWidth={2.5} />
        </div>
        <h2 className={styles["admin-code-sample__title"]}>Code Samples</h2>
      </div>

      {/* LANGUAGE TABS */}
      <div className={styles["admin-code-sample__tabs-wrapper"]}>
        <div className={styles["admin-code-sample__tabs"]}>
          {codeSamples.map((item) => (
            <button
              key={item.language}
              className={`${styles["admin-code-sample__tab"]} ${
                activeLang === item.language
                  ? styles["admin-code-sample__tab--active"]
                  : ""
              }`}
              onClick={() => handleTabClick(item.language)}
            >
              {item.language}
            </button>
          ))}
        </div>
      </div>

      {/* CODE BLOCK */}
      <div className={styles["admin-code-sample__code-wrapper"]}>
        <button
          className={`${styles["admin-code-sample__copy-btn"]} ${
            copied ? styles["admin-code-sample__copy-btn--success"] : ""
          }`}
          onClick={handleCopy}
          title="Copy to clipboard"
        >
          {copied ? <Check size={16} /> : <Copy size={16} />}
        </button>

        {copied && (
          <span className={styles["admin-code-sample__copy-feedback"]}>
            Copied!
          </span>
        )}

        <pre className={styles["admin-code-sample__pre"]}>
          <code>{activeCode}</code>
        </pre>
      </div>
    </div>
  );
};

export default CodeSample;
